import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Observable } from "rxjs";
import { NotificationsDialogOptions } from "./notifications-dialog";
import { NotificationsDialogComponent } from "./notifications-dialog.component";


@Injectable()
export class NotificationsDialogService {

    constructor(private matDialog: MatDialog) {}

    // #region Close All Dialogs Service Call

    CloseAllDialogs(): void {
        this.matDialog.closeAll();
    }

    // #endregion

    // #region Open Notifications Dialog Service Call

    Open(options?: NotificationsDialogOptions): Observable<any> {
        const self = this;

        const openHandle = self.matDialog.open<NotificationsDialogComponent>(NotificationsDialogComponent, {
            disableClose: true,
            data: {
                TitleText: 'Notification Details',
                MessageText: '',
                OKText: 'OK',
                Details: null,
                ...options,
            },
            // width: self.smallMediaSize ? '80vw' : options?.width || '600px',
            // height: self.smallMediaSize ? '80vh' : options?.height || '400px',
            maxHeight: '85vh',
        });

        return openHandle.afterClosed();
    }

    // #endregion
}